import { api } from 'api/axios';
import urls from 'engine/urls';
import { useQuery } from '@tanstack/react-query';

const getKeyValueStore = (params) => 
{    
    return api.get(urls().KeyValueStoreGlobal + "/"+ params.key);
}

export const useGetKeyValueStore = (params, options = {}) =>
    useQuery({
        queryKey: ['KeyValueStore',params],
        queryFn: () => getKeyValueStore(params),         
        ...options,
  });

